import variableColors from "@/base/global/variables/figma.colors.json";

export const carouselThemeToken: any = {
  //=================== COLOR =========================/
  colorBgContainer: variableColors["ColorFigmaComplementaryBlue50"],
  arrowBg: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],
  dotActiveWidth: 24,
  dotHeight: 10,
  dotWidth: 16,
  arrowSize: 36,
};
